import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { PANORAMA_SIZE, getImageSize } from '@core/helpers/getSlideSize';
import { MediaInfo } from '@core/models/media-info.model';

import * as PAN from 'panolens';

@Component({
  selector: 'app-gallery-panorama',
  templateUrl: './gallery-panorama.component.html',
  styleUrls: ['./gallery-panorama.component.scss']
})
export class GalleryPanoramaComponent implements AfterViewInit, OnDestroy {
  @Input() panorama: MediaInfo;
  @Input() index: number;
  @Output() handleSlideEvent = new EventEmitter<object>();
  @ViewChild('PanoContainer') panoContainer: ElementRef<HTMLElement>;

  viewer!: any;
  isLoading = true;
  width = getImageSize(PANORAMA_SIZE).width;
  height = getImageSize(PANORAMA_SIZE).height;

  constructor() {   }

  ngAfterViewInit(): void {
    if (this.panorama) {
      this.handleSlideEvent.emit({ width: this.width, index: this.index });
      this.createPanorama(this.panorama.url);
    }
  }

  ngOnDestroy(): void {
    this.viewer.destroy();
  }

  createPanorama(url) {
    const panorama = new PAN.ImagePanorama(url);
    this.viewer = new PAN.Viewer({
      container: this.panoContainer.nativeElement,
      controlButtons: ['fullscreen'],
      cameraFov: 100,

    });

    this.viewer.add(panorama);

    panorama.addEventListener('load', () => {
      this.isLoading = false;
    });
  }

}
